import { ReactNode } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { resultSelector } from '@/services/slices/questionSlice'
import { ShareIcon, TelegramIcon, VkIcon } from '@/ui/icons/socialIcons'
import classNames from 'classnames'
import qs from 'qs'

import styles from './ResultCard.module.scss'

type ResultCardProps = {
  text: ReactNode
}

const ResultCard: React.FC<ResultCardProps> = ({ text }) => {
  const { corrects, questions } = useSelector(resultSelector)

  const { search } = useLocation()

  const isCopy = search.includes('copy=true')

  return (
    <div className={styles.card}>
      <p
        className={classNames(
          'text',
          't-body-large',
          'text_color_primary',
          styles.result,
        )}
      >
        Результат: {corrects}/{questions}
      </p>
      <p
        className={classNames(
          'text',
          't-caption-big',
          'text_color_tertiary',
          styles.description,
        )}
      >
        {text}
      </p>
      {!isCopy && (
        <div className={styles.nav}>
          <span
            className={classNames(
              'text',
              't-caption-big',
              'text_color_primary',
              styles.share,
            )}
          >
            Поделиться <br /> результатом
          </span>
          <div className={styles.icons_wrapper}>
            <CopyToClipboard text={`${location.href}?copy=true`}>
              <div className={styles.icons_wrapper_icon}>
                <ShareIcon />
              </div>
            </CopyToClipboard>

            <a
              className={styles.icons_wrapper_icon}
              href={`http://vk.com/share.php?${qs.stringify({
                url: `${location.href}?copy=true`,
                title:
                  'Проверь свои знания о самых-самых объектах России вместе с 2ГИС',
                image: `https://2gis.nagge.ru/images/vk${corrects}.png`,
              })}`}
              target="_blank"
            >
              <VkIcon />
            </a>
            <a
              className={styles.icons_wrapper_icon}
              href={`https://telegram.me/share/url?url=${`${location.href}?copy=true`}&text=Проверь свои знания о самых-самых объектах России вместе с 2ГИС`}
              target="_blank"
            >
              <TelegramIcon />
            </a>
          </div>
        </div>
      )}
    </div>
  )
}

export default ResultCard
